import React, { Component } from 'react';
import Clear_Filter_icon from '../../../../../Images/Daikin_Images/image/Filtersign.png';

export default class Clear_Filter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			is_tapped: false,
		}
	}

	handleClearFilter = () => {
		this.setState({ is_tapped: true })
		this.props.handleClearFilter();
	}

	render() {
		let bg_colour = 'unset';
		let opacity = 1;
		let cursor = 'pointer';

		if (this.state.is_tapped) {
			bg_colour = this.props.colours.button_light_gray;
			opacity = 0.3;
			cursor = 'default';
		}

		let style = Object.assign({ backgroundColor: bg_colour, opacity: opacity, cursor: cursor }, this.props.style);

		return (
			<div id='cl_filter' style={style} onClick={this.handleClearFilter}>
				<div style={{ padding: 10, }}>
					<div style={{ display: 'inline-block', }}>
						<div style={{ display: 'inline-block' }}>
							<img src={Clear_Filter_icon} style={{ width: 25 }} />
						</div>
						<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 5, marginLeft: 10 }}>
							<span> {this.props.receiver.getString('cl_filter')} </span>
						</div>

					</div>
				</div>
			</div>
		)
	}
}